module.exports = __webpack_public_path__ + "df5bf9c50b9cb1edb5cc30fc7a8a363c.png";